
//import errorHandler from './errorHandler'
import axios from 'axios'
import _ from 'lodash'

export default {
    send : (payload, next) => {
        axios.post('https://hooks.slack.com/services/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', payload,(err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/slack.js